import apiClient from './apiClient';

// Menu service — mirrors r2b-restaurant-mobile-new/src/services/menuService.js.

export const getFoodItems = async (branchId) => {
  const response = await apiClient.get(`/food-items/${branchId}`);
  return response.data;
};

export const getFoodItemById = async (foodItemId) => {
  const response = await apiClient.get(`/food-item-id/${foodItemId}`);
  return response.data;
};

export const createFoodItem = async (branchId, foodItemData) => {
  const response = await apiClient.post(`/food-items/${branchId}`, foodItemData);
  return response.data;
};

export const updateFoodItem = async (foodItemId, updateData, branchId) => {
  const response = await apiClient.put(`/food-items/${foodItemId}?branch=${branchId}`, updateData);
  return response.data;
};

export const deleteFoodItem = async (foodItemId, branchId) => {
  const response = await apiClient.delete(`/food-items/${foodItemId}?branch=${branchId}`);
  return response.data;
};

export const getCategories = async (branchId) => {
  const response = await apiClient.get(`/categories/${branchId}`);
  return response.data;
};
